export let LanguageStatus = /*#__PURE__*/function (LanguageStatus) {
  LanguageStatus["INACTIVE"] = "Inactive";
  LanguageStatus["ACTIVE"] = "Active";
  LanguageStatus["DELETED"] = "Deleted";
  return LanguageStatus;
}({});
//# sourceMappingURL=enums.js.map